import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {StyledGridContainer, StyledResponsiveGrid} from './style'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {StyledCard} from '../user-group-card/style'
export const UserGroupsGridSkeleton = () => {
    return (
        <StyledGridContainer>
            <StyledResponsiveGrid columns={3} gap={4}>
                {Array.from({length: 6}).map((_, index) => (
                    <SkeletonCard key={index} />
                ))}
            </StyledResponsiveGrid>
        </StyledGridContainer>
    )
}

const SkeletonCard = () => {
    return (
        <StyledCard direction="column" gap={4}>
            <Skeleton width="24px" height="24px" style={{borderRadius: '50%'}} />

            <Flexbox direction="column" gap={1}>
                <Skeleton width="80%" height="20px" />
                <Skeleton width="50%" height="16px" />
            </Flexbox>

            <Skeleton width="120px" height="12px" />
        </StyledCard>
    )
}
